import { render, staticRenderFns } from "./EmbedCarousel.vue?vue&type=template&id=396ef1f2&scoped=true"
import script from "./EmbedCarousel.vue?vue&type=script&lang=js"
export * from "./EmbedCarousel.vue?vue&type=script&lang=js"
import style0 from "./EmbedCarousel.vue?vue&type=style&index=0&id=396ef1f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396ef1f2",
  null
  
)

export default component.exports